import script from "./AddAuthorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAuthorForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__